import {
  PaymentMethod,
} from "@/Enums";

import {
  PaymentDetailsDto,
} from "@/model/PaymentDetailsDto";

import moment from "moment";

import {
  DateFormats,
} from "@/scripts/Common/DateFormats";

import {
  isEmpty,
} from "@/scripts/Common/HelperFunctions";

class PaymentDetails {

    paymentDetailsDto: PaymentDetailsDto = new PaymentDetailsDto();

    paymentMethod: PaymentMethod = PaymentMethod.invoice;

    sepaDebitDate: string | undefined;

    mandateReference: string | undefined | null;

    constructor(paymentDetailsDto: PaymentDetailsDto) {
        this.SetValues(paymentDetailsDto);
    }

    public SetValues(paymentDetailsDto: PaymentDetailsDto) {
        this.paymentDetailsDto = paymentDetailsDto;
        this.paymentMethod = paymentDetailsDto.paymentMethod;
        this.sepaDebitDate = this.FormatDate(paymentDetailsDto.sepaDebitDate, DateFormats.ISO8601_LONG);
        this.mandateReference = paymentDetailsDto.mandateReference;
        this.paymentDetailsDto.sepaDebitDate = this.FormatDate(paymentDetailsDto.sepaDebitDate, DateFormats.ISO8601_LONG);
    }

    private FormatDate(date: string | undefined, format: string) {
        return date
            ? moment(this.paymentDetailsDto.sepaDebitDate).format(format)
            : date;
    }

    public Reset() {
        this.paymentMethod = this.paymentDetailsDto.paymentMethod;
        this.sepaDebitDate = this.paymentDetailsDto.sepaDebitDate;
        this.mandateReference = this.paymentDetailsDto.mandateReference;
    }

    get HasChanges() {
        return this.paymentMethod !== this.paymentDetailsDto.paymentMethod
            || this.sepaDebitDate !== this.paymentDetailsDto.sepaDebitDate
            || this.mandateReference !== this.paymentDetailsDto.mandateReference;
    }

    public IsSepaDebitMethod() {
        return this.paymentMethod === PaymentMethod.companyDebit || this.paymentMethod === PaymentMethod.baseDebit;
    }

    public GetModel() {
        let model = new PaymentDetailsDto();

        model.id = this.paymentDetailsDto.id;
        model.paymentMethod = this.paymentMethod;
        model.sepaDebitDate = isEmpty(this.sepaDebitDate) ? undefined : this.sepaDebitDate;
        model.mandateReference = this.mandateReference;

        return model;
    }
}

export {
    PaymentDetails
}
